import { createSelector } from 'reselect';
import { getKaMetlhaFuneralClaim } from './index';
import { API_CALL_STATUS, FORM_STATUS } from '../../reducers/status';

export const getReferenceData = createSelector(
    getKaMetlhaFuneralClaim,
    (kaMetlhaFuneralClaim) => kaMetlhaFuneralClaim.referenceData
);
export const getReferenceDataApiStatus = createSelector(getReferenceData, (referenceData) => referenceData.apiStatus);
export const getReferenceNumber = createSelector(getReferenceData, (referenceData) => referenceData.buyRef);
export const getIsApiStatus = (status,apiFor) =>
    createSelector(getReferenceDataApiStatus, (apiStatus) => (apiStatus?.status === status && apiStatus?.apiFor === apiFor));
export const getApplicationReferenceData = createSelector(
    getReferenceData,
    (applicationReferenceData) => applicationReferenceData.applicationData
);

const makeGetField = (fieldId) => createSelector(getApplicationReferenceData, (data) => data[fieldId]);

export const getReferenceBankData = makeGetField('bankData');
export const getReferenceBranchCodesData = makeGetField('branchCodesData');

export const getReferenceDistricts = () => [
    {
        code: '01',
        description: 'Central',
    },
    {
        code: '02',
        description: 'Chobe',
    },
    {
        code: '03',
        description: 'Ghanzi',
    },
    {
        code: '04',
        description: 'Kgalagadi',
    },
    {
        code: '05',
        description: 'Kgatleng',
    },
    {
        code: '06',
        description: 'Kweneng',
    },
    {
        code: '07',
        description: 'North-East',
    },
    {
        code: '08',
        description: 'North-West/Ngamiland',
    },
    {
        code: '09',
        description: 'South-East',
    },
    {
        code: '10',
        description: 'Southern',
    },
];
export const getReferenceAccountTypes = () => [
    {
        description: 'Savings',
        code: '01',
    },
    {
        description: 'Current',
        code: '02',
    },
];

export const getReferenceDataOptions = () => ({
    residencePeriod: [
      { description: 'Less than two years', code: 'Less than two years' },
      { description: 'More than two years', code: 'More than two years' },
    ],
    referenceNationality: [
        { description: 'Afghanistan', code: 'Afghanistan' },
        { description: 'Albania', code: 'Albania' },
        { description: 'Algeria', code: 'Algeria' },
        { description: 'Andorra', code: 'Andorra' },
        { description: 'Angola', code: 'Angola' },
        { description: 'Anguilla', code: 'Anguilla' },
        { description: 'Antigua And Barbuda', code: 'Antigua And Barbuda' },
        { description: 'Argentina', code: 'Argentina' },
        { description: 'Armenia', code: 'Armenia' },
        { description: 'Aruba', code: 'Aruba' },
        { description: 'Jordan', code: 'Jordan' },
        { description: 'Kazakhstan', code: 'Kazakhstan' },
        { description: 'Kenya', code: 'Kenya' },
        { description: 'Kiribati', code: 'Kiribati' },
        { description: 'Korea, Republic (South)', code: 'Korea, Republic (South)' },
        { description: 'Kosovo', code: 'Kosovo' },
        { description: 'Kuwait', code: 'Kuwait' },
        { description: 'Laos', code: 'Laos' },
        { description: 'Latvia', code: 'Latvia' },
        { description: 'Ascension And St-Helena', code: 'Ascension And St-Helena' },
        { description: 'Lebanon', code: 'Lebanon' },
        { description: 'Lesotho', code: 'Lesotho' },
        { description: 'Liberia', code: 'Liberia' },
        { description: 'Libya', code: 'Libya' },
        { description: 'Lithuania', code: 'Lithuania' },
        { description: 'Luxemburg', code: 'Luxemburg' },
        { description: 'Macao', code: 'Macao' },
        { description: 'Macedonia', code: 'Macedonia' },
        { description: 'Madagascar', code: 'Madagascar' },
        { description: 'Malawi', code: 'Malawi' },
        { description: 'Australia', code: 'Australia' },
        { description: 'Malaysia', code: 'Malaysia' },
        { description: 'Maldives', code: 'Maldives' },
        { description: 'Mali', code: 'Mali' },
        { description: 'Malta', code: 'Malta' },
        { description: 'Martinique', code: 'Martinique' },
        { description: 'Mauritania', code: 'Mauritania' },
        { description: 'Mauritius', code: 'Mauritius' },
        { description: 'Mexico', code: 'Mexico' },
        { description: 'Moldova', code: 'Moldova' },
        { description: 'Austria', code: 'Austria' },
        { description: 'Mongolia', code: 'Mongolia' },
        { description: 'Montenegro', code: 'Montenegro' },
        { description: 'Montserrat', code: 'Montserrat' },
        { description: 'Mozambique', code: 'Mozambique' },
        { description: 'Myanmar', code: 'Myanmar' },
        { description: 'Namibia', code: 'Namibia' },
        { description: 'Nauru', code: 'Nauru' },
        { description: 'Nepal', code: 'Nepal' },
        { description: 'Netherlands', code: 'Netherlands' },
        { description: 'Azerbaidjan', code: 'Azerbaidjan' },
        { description: 'Netherlands Antilles', code: 'Netherlands Antilles' },
        { description: 'New Caledonia', code: 'New Caledonia' },
        { description: 'New Zealand', code: 'New Zealand' },
        { description: 'Nicaragua', code: 'Nicaragua' },
        { description: 'Niger', code: 'Niger' },
        { description: 'Nigeria', code: 'Nigeria' },
        { description: 'Niu Island', code: 'Niu Island' },
        { description: 'North Korea', code: 'North Korea' },
        { description: 'Norway', code: 'Norway' },
        { description: 'Oman', code: 'Oman' },
        { description: 'Bahamas', code: 'Bahamas' },
        { description: 'Pakistan', code: 'Pakistan' },
        { description: 'Panama', code: 'Panama' },
        { description: 'Papua New Guinea', code: 'Papua New Guinea' },
        { description: 'Paraguay', code: 'Paraguay' },
        { description: 'Peru', code: 'Peru' },
        { description: 'Philippines', code: 'Philippines' },
        { description: 'Pitcairn Islands', code: 'Pitcairn Islands' },
        { description: 'Poland', code: 'Poland' },
        { description: 'Portugal', code: 'Portugal' },
        { description: 'Qatar', code: 'Qatar' },
        { description: 'Bahrain', code: 'Bahrain' },
        { description: 'Reunion', code: 'Reunion' },
        { description: 'Romania', code: 'Romania' },
        { description: 'Russia', code: 'Russia' },
        { description: 'Rwanda', code: 'Rwanda' },
        { description: 'Samoa', code: 'Samoa' },
        { description: 'Sao Tome And Principe', code: 'Sao Tome And Principe' },
        { description: 'Saudi Arabia', code: 'Saudi Arabia' },
        { description: 'Senegal', code: 'Senegal' },
        { description: 'Serbia', code: 'Serbia' },
        { description: 'Seychelles', code: 'Seychelles' },
        { description: 'Bangladesh', code: 'Bangladesh' },
        { description: 'Sierra Leone', code: 'Sierra Leone' },
        { description: 'Singapore', code: 'Singapore' },
        { description: 'Slovakia', code: 'Slovakia' },
        { description: 'Slovenia', code: 'Slovenia' },
        { description: 'Solomon Islands', code: 'Solomon Islands' },
        { description: 'Somalia', code: 'Somalia' },
        { description: 'South Africa', code: 'South Africa' },
        { description: 'Spain', code: 'Spain' },
        { description: 'Sri Lanka', code: 'Sri Lanka' },
        { description: 'St Kitts And Nevis', code: 'St Kitts And Nevis' },
        { description: 'Barbados', code: 'Barbados' },
        { description: 'St Lucia', code: 'St Lucia' },
        { description: 'St Pierre And Miquelon', code: 'St Pierre And Miquelon' },
        { description: 'St Vincent And The Grenadines', code: 'St Vincent And The Grenadines' },
        { description: 'Sudan', code: 'Sudan' },
        { description: 'South Sudan', code: 'South Sudan' },
        { description: 'Suriname', code: 'Suriname' },
        { description: 'Turks & Caicos Islands', code: 'Turks & Caicos Islands' },
        { description: 'Tuvalu', code: 'Tuvalu' },
        { description: 'Uganda', code: 'Uganda' },
        { description: 'Ukraine', code: 'Ukraine' },
        { description: 'United Arab Emirates', code: 'United Arab Emirates' },
        { description: 'Uruguay', code: 'Uruguay' },
        { description: 'Usa', code: 'Usa' },
        { description: 'Uzbekistan', code: 'Uzbekistan' },
        { description: 'Belize', code: 'Belize' },
        { description: 'Vanuatu', code: 'Vanuatu' },
        { description: 'Vatican', code: 'Vatican' },
        { description: 'Venezuela', code: 'Venezuela' },
        { description: 'Vietnam', code: 'Vietnam' },
        { description: 'Wallis And Futuna Islands', code: 'Wallis And Futuna Islands' },
        { description: 'Yemen', code: 'Yemen' },
        { description: 'Zambia', code: 'Zambia' },
        { description: 'Zimbabwe', code: 'Zimbabwe' },
        { description: 'Benin', code: 'Benin' },
        { description: 'Bermuda', code: 'Bermuda' },
        { description: 'Bhutan', code: 'Bhutan' },
        { description: 'Bolivia', code: 'Bolivia' },
        { description: 'Bosnia Herzegovina', code: 'Bosnia Herzegovina' },
        { description: 'Botswana', code: 'Botswana' },
        { description: 'Brazil', code: 'Brazil' },
        { description: 'British Virgin Island', code: 'British Virgin Island' },
        { description: 'Brunei Darussalam', code: 'Brunei Darussalam' },
        { description: 'Bulgaria', code: 'Bulgaria' },
        { description: 'Burkina Faso', code: 'Burkina Faso' },
        { description: 'Burundi', code: 'Burundi' },
        { description: 'Cambodia', code: 'Cambodia' },
        { description: 'Cameroon', code: 'Cameroon' },
        { description: 'Canada', code: 'Canada' },
        { description: 'Cape Verde', code: 'Cape Verde' },
        { description: 'Cayman Islands', code: 'Cayman Islands' },
        { description: 'Central African Republic', code: 'Central African Republic' },
        { description: 'Chad', code: 'Chad' },
        { description: 'Chile', code: 'Chile' },
        { description: 'China', code: 'China' },
        { description: 'Colombia', code: 'Colombia' },
        { description: 'Comoros', code: 'Comoros' },
        { description: 'Congo', code: 'Congo' },
        { description: 'Cook Islands', code: 'Cook Islands' },
        { description: 'Costa Rica', code: 'Costa Rica' },
        { description: 'Croatia', code: 'Croatia' },
        { description: 'Cuba', code: 'Cuba' },
        { description: 'Cyprus', code: 'Cyprus' },
        { description: 'Czech Republic', code: 'Czech Republic' },
        { description: 'Denmark', code: 'Denmark' },
        { description: 'Djibouti', code: 'Djibouti' },
        { description: 'Dominica', code: 'Dominica' },
        { description: 'Dominican Republic', code: 'Dominican Republic' },
        { description: 'Ecuador', code: 'Ecuador' },
        { description: 'Egypt', code: 'Egypt' },
        { description: 'El Salvador', code: 'El Salvador' },
        { description: 'Equatorial Guinea', code: 'Equatorial Guinea' },
        { description: 'Eritrea', code: 'Eritrea' },
        { description: 'Estonia', code: 'Estonia' },
        { description: 'Ethiopia', code: 'Ethiopia' },
        { description: 'Falkland Islands', code: 'Falkland Islands' },
        { description: 'Faröe Islands', code: 'Faröe Islands' },
        { description: 'Fiji', code: 'Fiji' },
        { description: 'Finland', code: 'Finland' },
        { description: 'France', code: 'France' },
        { description: 'French Guiana', code: 'French Guiana' },
        { description: 'French Polynesia', code: 'French Polynesia' },
        { description: 'Gabon', code: 'Gabon' },
        { description: 'Gambia', code: 'Gambia' },
        { description: 'Georgia', code: 'Georgia' },
        { description: 'Germany', code: 'Germany' },
        { description: 'Ghana', code: 'Ghana' },
        { description: 'Gibraltar', code: 'Gibraltar' },
        { description: 'Great Britain', code: 'Great Britain' },
        { description: 'Greece', code: 'Greece' },
        { description: 'Greenland', code: 'Greenland' },
        { description: 'Grenada', code: 'Grenada' },
        { description: 'Guadeloupe', code: 'Guadeloupe' },
        { description: 'Guatemala', code: 'Guatemala' },
        { description: 'Guinea', code: 'Guinea' },
        { description: 'Guinea-Bissau', code: 'Guinea-Bissau' },
        { description: 'Guyana', code: 'Guyana' },
        { description: 'Haiti', code: 'Haiti' },
        { description: 'Honduras', code: 'Honduras' },
        { description: 'Hong Kong', code: 'Hong Kong' },
        { description: 'Hungary', code: 'Hungary' },
        { description: 'Iceland', code: 'Iceland' },
        { description: 'India', code: 'India' },
        { description: 'Indonesia', code: 'Indonesia' },
        { description: 'Iran', code: 'Iran' },
        { description: 'Iraq', code: 'Iraq' },
        { description: 'Ireland', code: 'Ireland' },
        { description: 'Israel', code: 'Israel' },
        { description: 'Italy', code: 'Italy' },
        { description: 'Ivory Coast', code: 'Ivory Coast' },
        { description: 'Jamaica', code: 'Jamaica' },
        { description: 'Japan', code: 'Japan' },
        { description: 'Eswatini', code: 'Eswatini' },
        { description: 'Sweden', code: 'Sweden' },
        { description: 'Switzerland', code: 'Switzerland' },
        { description: 'Syria', code: 'Syria' },
        { description: 'Taiwan', code: 'Taiwan' },
        { description: 'Belarus', code: 'Belarus' },
        { description: 'Tajikistan', code: 'Tajikistan' },
        { description: 'Tanzania', code: 'Tanzania' },
        { description: 'Thailand', code: 'Thailand' },
        { description: 'Timor-Leste', code: 'Timor-Leste' },
        { description: 'Togo', code: 'Togo' },
        { description: 'Tokelau Islands', code: 'Tokelau Islands' },
        { description: 'Tonga', code: 'Tonga' },
        { description: 'Trinidad And Tobago', code: 'Trinidad And Tobago' },
        { description: 'Tristan Da Cunha', code: 'Tristan Da Cunha' },
        { description: 'Tunisia', code: 'Tunisia' },
        { description: 'Belgium', code: 'Belgium' },
        { description: 'Turkey', code: 'Turkey' },
        { description: 'Turkmenistan', code: 'Turkmenistan' },
    ],
    refrenceEmployeType: [
        { description: 'Employed', code: 'Employed' },
        { description: 'Self Employed', code: 'Self Employed' },
        { description: 'Unemployed', code: 'Unemployed' },
    ],
    refrenceSourceOfIncome: [
        { description: 'Salary ', code: 'Salary ' },
        { description: 'Business or Self-Employment', code: 'Business or Self-Employment' },
        { description: 'Investments ', code: 'Investments ' },
        { description: 'Gifts or Inheritance ', code: 'Gifts or Inheritance ' },
        { description: 'Loan ', code: 'Loan ' },
        { description: 'Other', code: 'Other' },
    ],
    referenceEmployeeOccupation:[
        { description: 'Health care provider', code: 'Health care provider' },
        { description: 'Pilot', code: 'Pilot' },
        { description: 'Accountant/audit ', code: 'Accountant/audit ' },
        { description: 'Banker', code: 'Banker' },
        { description: 'Lawyer ', code: 'Lawyer ' },
        { description: 'Diplomat', code: 'Diplomat' },
        { description: 'Pensioner', code: 'Pensioner' },
        { description: 'Risk and Compliance', code: 'Risk and Compliance' },
        { description: 'Manager', code: 'Manager' },
        { description: 'Cleaner ', code: 'Cleaner ' },
        { description: 'Military', code: 'Military' },
        { description: 'Scientist', code: 'Scientist' },
        { description: 'Self employed', code: 'Self employed' },
        { description: 'Other', code: 'Other' },
    ]
});
